module.exports = __webpack_public_path__ + "img/tutorial_war_01.8dc3f216.gif";